import { DefaultValues } from "react-hook-form";
import { FetchCUPSAvailabilityData, FetchCUPSPowerPeriodKeys } from "../../../types/cups"
import { StepElecContractFormData } from "../types/FormContract";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";
import { FormContractSchema } from "../schema/FormContractSchema";

export const useFormContract = (
  contractStep: StepElecContractFormData,
  installationCUPSSIPSData: FetchCUPSAvailabilityData
) => {

  const Settings = useSettingsContext();

  // Hacky workaround for the shit naming I did in FetchCUPSAvailabilityData
  const getSIPSPowerData = (
    power: 0 | 1 | 2 | 3 | 4 | 5
  ) => {

    const installationCUPSSIPSDataKeys = [
      "power", "power2", "power3", "power4", "power5", "power6"
    ] as const satisfies FetchCUPSPowerPeriodKeys[];

    const validatePowerVal = installationCUPSSIPSData[installationCUPSSIPSDataKeys[power]];

    return !!validatePowerVal ? validatePowerVal : 0;
  }

  const validationSchema = FormContractSchema(Settings);

  const SIPSPowerDataValid = (
    installationCUPSSIPSData.sipsDataAvailable && 
    typeof installationCUPSSIPSData.power == "number" &&
    typeof installationCUPSSIPSData.power2 == "number"
  ) 

  const defaultSIPSValues: DefaultValues<StepElecContractFormData> = {
    ...contractStep,
    ...(SIPSPowerDataValid && {
      powers: {
        current: [
            getSIPSPowerData(0),
            getSIPSPowerData(1)
          ].some(val => val > 15) ? 
            {
              installationType: "industrial",
              periods: [
                getSIPSPowerData(0),
                getSIPSPowerData(1),
                getSIPSPowerData(2),
                getSIPSPowerData(3),
                getSIPSPowerData(4),
                getSIPSPowerData(5),
              ]
            } : {
              installationType: 'domestic',
              periods: [
                getSIPSPowerData(0),
                getSIPSPowerData(1)
              ]
            },
          change: false
        },
      }
    ),
    ...(installationCUPSSIPSData.accessTariff && {
      accessTariff: {
        id: installationCUPSSIPSData.accessTariff,
        name: installationCUPSSIPSData.accessTariffName
      }
    }),
    ...(installationCUPSSIPSData.selfcons && {
      selfcons: {
        enabled: true,
        code: installationCUPSSIPSData.selfconsCode,
        attachments: []
      }
    })
  }

  return {
    defaultSIPSValues,
    SIPSPowerDataValid,
    validationSchema,
    getSIPSPowerData
  }
}
